import * as React from "react";

import type { ImageSlideProps } from "./interface";

export const ImageSlide = ({ alt, src, height = 240 }: Omit<ImageSlideProps, "type">): JSX.Element => {
  return <img alt={alt} height={height} src={src} />;
};
